export default {
  live: {
    en: 'Live',
  },
}
